module.exports = __webpack_public_path__ + "img/3.e7bee730.png";